// src/pages/IslamicFinanceBlog.js
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { trackEvent, EVENT_TYPE_PAGE } from "../utils/trackEvent.jsx";

// Sample blog posts data - replace with your actual blog posts
const blogPosts = [
  {
    id: 1,
    slug: "things-to-remember-while-applying-for-riba-free-loans",
    title: "Things to Remember While Applying for Riba-Free Loans: A Guide for Small Businesses & Nonprofits",
    excerpt: "For many small businesses and nonprofits, access to financing is crucial—whether it's to grow your operations, invest in equipment, manage cash flow, or expand your impact...",
    date: "April 30, 2025",
    author: "Sabina Yasmin",
    image: "/blog1.jpg"
  },
  {
    id: 2,
    slug: "halal-investment-opportunities",
    title: "Halal Investment Opportunities",
    excerpt: "Discover various halal investment options available for Muslim investors...",
    date: "March 10, 2024",
    author: "Dr. Ahmed Hassan",
    image: "/blog2.jpg"
  }
  // Add more blog posts as needed
];

function IslamicFinanceBlog() {
  useEffect(() => {
    trackEvent(EVENT_TYPE_PAGE);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f8fafc] to-[#e2e8f0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#1a4a1a] mb-12">
          HalalCred Blog
        </h1>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              {/*<div className="aspect-w-16 aspect-h-9">
                <img
                  src={post.image}
                  alt={post.title}
                  className="object-cover w-full h-full"
                />
              </div>*/}
              <div className="p-6">
                <h2 className="text-xl font-semibold text-[#1a4a1a] mb-2">
                  {post.title}
                </h2>
                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                <div className="flex justify-between items-center text-sm text-gray-500">
                  <span>{post.author}</span>
                  <span>{post.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IslamicFinanceBlog;
